module.exports = __webpack_public_path__ + "yeni beyaz mutfak.jpeg?f399c0d9e938a703d8c01b4cb57feae1";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/yeni beyaz mutfak.jpeg
// module id = 371
// module chunks = 0